module.exports = __webpack_public_path__ + "img/launch.376f5fe4.png";